export default [
  {
    id: 1,
    title: "ગુજરાતી કક્કો",
    category: "",
    icon: "bal_vibhag/paku_kariye/title_images/kakko.png",
    color1: "#968bf7",
    color2: "#1c00ff",
    screen: "Kakko",
    paku_kariye_id: "gujarati_kakko",
    route: "/gujarati-kakko",
  },
  {
    id: 2,
    title: "અંગ્રેજી એબીસીડી",
    category: "",
    icon: "bal_vibhag/paku_kariye/title_images/abc.png",
    color1: "#baf7bc",
    color2: "#00cf07",
    screen: "Kakko",
    paku_kariye_id: "english_abcd",
    route: "/english-abcd",
  },
  {
    id: 3,
    title: "હિન્દી કક્કો",
    category: "",
    icon: "bal_vibhag/paku_kariye/title_images/hindi.png",
    color1: "#edcf95",
    color2: "#ffa600",
    screen: "Kakko",
    paku_kariye_id: "hindi_kakko",
    route: "/hindi-kakko",
  },
  {
    id: 4,
    title: "ગુજરાતી એકડા",
    category: "",
    icon: "bal_vibhag/paku_kariye/title_images/numger_guj.png",
    color1: "#faa1a0",
    color2: "#ff1715",
    screen: "Ekada",
    paku_kariye_id: "gujarati_ekada",
    route: "/gujarati-ekada",
  },
  {
    id: 5,
    title: "અંગ્રેજી એકડા",
    category: "",
    icon: "bal_vibhag/paku_kariye/title_images/number.png",
    color1: "#f09eef",
    color2: "#c900c8",
    screen: "Ekada",
    paku_kariye_id: "english_ekada",
    route: "/english-ekada",
  },
  {
    id: 6,
    title: "હિન્દી એકડા",
    category: "",
    icon: "bal_vibhag/paku_kariye/title_images/hindi-number.png",
    color1: "#ffef15",
    color2: "#ce7f33",
    screen: "Ekada",
    paku_kariye_id: "hindi_ekada",
    route: "/hindi-ekada",
  },
  {
    id: 7,
    title: "1-30 ઘડિયા",
    category: "",
    icon: "bal_vibhag/paku_kariye/title_images/calculator.png",
    color1: "#e8a884",
    color2: "#88411a",
    screen: "GhadiyaList",
    paku_kariye_id: "ghadiya",
    route: "/ghadiya",
  },
];

